import { useTheme } from "../../theme/useTheme"
import { Paper, type SxProps, type Theme } from "@mui/material"
import { type ReactNode } from "react"

interface SectionProps {
    children: ReactNode
    marginTop?: number
    marginBottom?: number
    sx?: SxProps<Theme>
}

export const Section = ({ children, marginTop = 0, marginBottom, sx }: SectionProps) => {
    const { layout } = useTheme()
    const defaultMarginBottom = layout.verticalSpacing * 3

    return (
        <Paper
            sx={{
                marginTop,
                marginBottom: marginBottom ?? defaultMarginBottom,
                background: "none",
                ...sx,
            }}
            elevation={0}
        >
            {children}
        </Paper>
    )
}
